export default "__VITE_ASSET__CdGCRgHg__"